import { render, staticRenderFns } from "./project_structure.vue?vue&type=template&id=7ec9c4bc&scoped=true"
import script from "./project_structure.vue?vue&type=script&lang=js"
export * from "./project_structure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec9c4bc",
  null
  
)

export default component.exports